import { Col, Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { extrasVM } from '../Extras.page';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { IconButton } from '@design-system/components/button/iconButton';

export const ExtrasEmptyState = () => {
  const vm = extrasVM.useValue();
  const shouldShowEmptyState = vm.isExtrasEmpty && vm.formType !== 'ContentTab';

  if (!shouldShowEmptyState) return null;

  return (
    <Row>
      <Col center gap="l">
        <Typography variant="headline" size="medium">
          Add your links
        </Typography>

        <Typography variant="body" size="large" fontWeight="normal">
          Add links to your content, special offers, or anything else you'd like
          your users aware of.
        </Typography>

        <IconButton
          onClick={() => vm.dispatch('Create', 'ContentLink')}
          variant="filled"
          color="neutral"
          testId="NewExtrasButton"
          icon={faPlus}
        >
          New
        </IconButton>
      </Col>
    </Row>
  );
};
